import React from "react";
import {Typography} from "@mui/material";
import DefaultLayoutNoSideBar from "../../layout/defaultLayoutNoSideBar";
import {getUserDetailsFromToken} from "../../utils/functions/userTokenDetails";
import {getUserToken} from "../../utils/functions/userToken";
import {ROUTES} from "../../utils/router";
import {Navigate} from "react-router-dom";
import {useSelector} from "react-redux";

const TransitionPageAdmin = () => {
    const { UserDetails } = getUserDetailsFromToken(getUserToken());
    const { accounts = [], accountsStatus } = useSelector(
        (state) => state?.account || {}
    );

    // Rendering a redirect instead of calling navigate() during render, which
    // React Router does not allow and which used to leave the page rendered.
    if (!UserDetails.isAdminUser && !UserDetails.isSuperAdminUser) {
        return <Navigate to={ROUTES.TRANSITION} replace />;
    }

    // Asking for a selection only makes sense when there is something to pick.
    const hasNoAccounts = accounts.length === 0 && accountsStatus === "succeeded";

    return (
        <DefaultLayoutNoSideBar>
            <Typography sx={{ mt: 4, textAlign: "center" }}>
                {hasNoAccounts
                    ? "No account available, please contact support."
                    : "Please select an account."}
            </Typography>
        </DefaultLayoutNoSideBar>
    );
};

export default TransitionPageAdmin;
